export const extractDataFromString = (text) => {
	if (typeof text !== 'string') {
		return null;
	}
	const parts = text.split('@');
	if (parts.length !== 3) {
		return null;
	}
	const id = parts[0];
	const url = parts[1];
	const characterType = parts[2];
	return { id, url, characterType };
};

export const base64Prefix = 'data:image/jpeg;base64,';
